import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { CommonServiceLayerService, RequestPayLoadFormat } from 'src/app/services/common-service-layer.service';
import { AlertService } from 'src/app/shared/alert.service';
import { ModalFilterData } from 'src/app/shared/shared-filter-modal/filter-modal/filter-modal-interface';
import { LayoutService } from 'src/app/layout/layout.service';
import { GlobalVariablesService } from 'src/app/layout/global-variables.service';
import { Config } from 'src/app/config/config';

@Component({
  selector: 'app-aqi-calender-view',
  templateUrl: './aqi-calender-view.component.html',
  styleUrls: ['./aqi-calender-view.component.scss']
})
export class AqiCalenderViewComponent implements OnInit {
  @Input() options: any = { loadType: 'month' };
  constructor(
    public sharedService: SharedService,
    public http: CommonServiceLayerService,
    public modalService: LayoutService,
    public aleret: AlertService,
    public layoutService: LayoutService,
    public globalVariables: GlobalVariablesService
  ) { }
  public responseData;
  public showModal = false;
  public modalData: ModalFilterData;
  public filterData = {};
  public errorStatusMessage;
  public aqiTableOptions;
  public checkBoxInput = { value: true, parameter: true };
  public showFilters = false;
  public printTables: any = { aqi: {}, aqiIndex: {} };
  public excelTables: any = { aqi: {}, aqiIndex: {} };
  ngOnInit() {
    this.subscribePopStatus();
    this.setDefaultOptions();
    this.aqiTableOptions = { checkBoxInput: this.checkBoxInput, additionalTable: true };
    this.getFilterData();
  }
  setDefaultOptions() {
    const options = {
      api: 'AQIMonthlyCalenderView', xAxis: 'Months', pageTitle: 'Month Wise AQI Report',
      // api: 'formJsonLoader', xAxis: 'Months', pageTitle: 'Month Wise AQI Report',
      print: {
        show: true,
        fileName: 'Month Wise AQI Report',
        headerLabel: 'value',
        headerContent: {
          ReportName: 'Month Wise AQI Report',
          ReportType: 'Month Wise AQI Report'
        }
      }
    };
    this.options = Object.assign(options, this.options);
  }
  subscribePopStatus() {
    try {
      this.modalService.getToggleModal().subscribe(response => {
        this.showModal = response;
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  /**
   * set modal data
   * @param data filter data
   */
  setModalData(data) {
    try {
      this.modalData = {
        buttons: [{ title: 'Fetch', actionType: 'fetch', class: 'btn btn-primary' }],
        headerTitle: this.options.pageTitle,
        formData: data,
        inputData: this.filterData,
        staticFields: this.globalVariables.FILTER_FORM_MAPPING.staticFields.month,
        width: '450',
        noDynamicFieldWidth: true
      };
    } catch (error) {
      Config.logger(error);
    }
  }

  /**
   * get filter data from API
   */
  getFilterData() {
    // try {
    //   let year = new Date().getFullYear();
    //   const options = [{
    //     placeholder: 'Year',
    //     type: 'select',
    //     name: 'Year',
    //     key: 'year',
    //     options: this.sharedService.getYears(2014, year + 1),
    //     required: true,
    //     bindValue: 'value',
    //     bindLabel: 'label'
    //   }];
    //   if (this.options.api !== 'AQIMonthlyCalenderView') {
    //     options.push({
    //       placeholder: 'Month',
    //       type: 'select',
    //       name: 'Month',
    //       key: 'month',
    //       options: this.sharedService.months,
    //       required: true,
    //       bindValue: 'value',
    //       bindLabel: 'label'
    //     });
    //   }
    //   this.setModalData(options);
    //   this.showModal = true;
    // } catch (error) {
    //   Config.logger(error);
    // }
    try {
      if (this.options.pageTitle === 'Month Wise AQI Report') {
        const payLoad = {
          loadType: 'monthWiseAQIReport'
        };
        const request: RequestPayLoadFormat = {
          api: 'formJsonLoader',
          method: 'postText',
          loader: true,
          type: 'API',
          hideErrorMessage: false,
          payLoad
        };
        this.http.API_REQUEST(request).subscribe(response => {
          this.setModalData(response.data.form);
          this.showModal = true;
        });
        return;
      }
    } catch (error) {
      Config.logger(error);
    }
    try {
      const payLoad = {
        loadType: 'dayWiseAQIReport'
      };
      const request: RequestPayLoadFormat = {
        api: 'formJsonLoader',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        this.setModalData(response.data.form);
        this.showModal = true;
      });
    } catch (error) {
      Config.logger(error);
    }

  }

  /**
   * modal action event
   * @param data to get the action type
   */
  modalActionEmitter(data) {
    try {
      if (data.button.actionType === 'fetch') {
        this.showFilters = true;
        const payLoad = data.payLoad;
        payLoad.loadType = this.options.loadType;
        this.getTableData(payLoad);
      }
    } catch (error) {
      Config.logger(error);
    }
  }

  getTableData(payLoad) {
    try {
      const request: RequestPayLoadFormat = {
        api: this.options.api,
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.responseData = this.errorStatusMessage = undefined;
      this.http.API_REQUEST(request).subscribe(response => {
        if (response && response.status === true) {
          this.appendMinMaxValues(response.data, this.options.api);
          this.modalService.setToggleModal(false);
          this.setPrintTables();
        } else {
          this.sharedService.serviceErrorMessage(response.message || 'Something went wrong');
          this.errorStatusMessage = response.message;
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  appendMinMaxValues(data, api) {
    try {
      if (api === 'AQIMonthlyCalenderView') {
        const minVales = { date: { value: 'Min' } };
        const maxVales = { date: { value: 'Max' } };
        const average = { date: { value: 'Average' } };
        data.aqi.tableData.headerContent[0].forEach(header => {
          data.aqi.tableData.bodyContent.forEach(row => {
            if (header.key !== 'date' && row[header.key] && !isNaN(row[header.key].value)) {
              row[header.key].value = Number(row[header.key].value);
              if (!minVales[header.key]) {
                minVales[header.key] = { value: row[header.key].value };
              }
              if (!maxVales[header.key]) {
                maxVales[header.key] = { value: 0 };
              }
              if (!average[header.key]) {
                average[header.key] = { sum: 0, count: 0 };
              }
              // min value
              if (minVales[header.key].value > row[header.key].value) {
                minVales[header.key].value = row[header.key].value;
              }
              // max value
              if (maxVales[header.key].value < row[header.key].value) {
                maxVales[header.key].value = row[header.key].value;
              }
              // average
              average[header.key].sum += Number(row[header.key].value);
              average[header.key].count++;
            }
          });
          if (header.key !== 'date' && average[header.key]) {
            average[header.key].value = (average[header.key].sum / average[header.key].count).toFixed(2);
          }
        });
        data.aqi.tableData.bodyContent.push(minVales);
        data.aqi.tableData.bodyContent.push(maxVales);
        data.aqi.tableData.bodyContent.push(average);
      } else {
        data.aqi.tableData.bodyContent.forEach(tr => {
          let maxVal;
          let minVal;
          let sum = 0;
          let counter = 0;
          data.aqi.tableData.headerContent[0].forEach(th => {
            if (th.key !== 'date' && tr[th.key] && !isNaN(tr[th.key].value)) {
              tr[th.key].value = Number(tr[th.key].value);
              if (!minVal) {
                minVal = tr[th.key].value;
              }
              if (!maxVal) {
                maxVal = tr[th.key].value;
              }
              counter++;
              sum += Number(tr[th.key].value);
              if (minVal > tr[th.key].value) {
                minVal = tr[th.key].value;
              }
              if (maxVal < tr[th.key].value) {
                maxVal = tr[th.key].value;
              }
            }
          });
          tr.minVal = { value: minVal || 'NA' };
          tr.maxVal = { value: maxVal || 'NA' };
          tr.average = { value: counter ? (sum / counter).toFixed(2) : 'NA' };
        });
        data.aqi.tableData.headerContent[0].push({ key: 'minVal', value: 'Min' });
        data.aqi.tableData.headerContent[0].push({ key: 'maxVal', value: 'Max' });
        data.aqi.tableData.headerContent[0].push({ key: 'average', value: 'Average', width: 100 });
      }
      this.responseData = data;
      Config.logger(this.responseData);
    } catch (error) {
      Config.logger(error);
    }
  }
  setPrintTables() {
    try {
      this.printTables = JSON.parse(JSON.stringify(this.responseData));
      this.excelTables = JSON.parse(JSON.stringify(this.responseData));
      ['aqi', 'aqiIndex'].forEach(ele => {
        this.printTables[ele].tableData.headerContent = this.printTables[ele].tableData.headerContent[0];
        this.printTables[ele].tableData.bodyContent.forEach(tr => {
          this.printTables[ele].tableData.headerContent.forEach(th => {
            if (tr[th.key]) {
              if (ele === 'aqi') {
                tr[th.key] = `${this.validStr(tr[th.key].value)} - ${tr[th.key].parameter || ' '}`;
              } else {
                tr[th.key] = `${this.validStr(tr[th.key].value)}`;
              }
            }
          });
        });
      });
      ['aqi', 'aqiIndex'].forEach(ele => {
        this.excelTables[ele].tableData.headerContent = this.excelTables[ele].tableData.headerContent[0];
        this.excelTables[ele].tableData.bodyContent.forEach(tr => {
          this.excelTables[ele].tableData.headerContent.forEach(th => {
            if (tr[th.key]) {
              tr[th.key] = `${this.validStr(tr[th.key].value)} - ${tr[th.key].parameter || ' '} - ${tr[th.key].color || ' '}`;
            }
          });
        });
      });
    } catch (error) {
      Config.logger(error);
    }
  }

  validStr(str) {
    if (str === undefined || str === null) {
      return ' ';
    } else {
      return str;
    }
  }

  openFilter() {
    try {
      this.showModal = true;
    } catch (error) {
      Config.logger(error);
    }
  }

}
